import { styled } from '@mui/material/styles';

export const Wrapper = styled('span')`
  display: flex;
  align-items: center;
`;
